import axios from 'axios';
import { Effect, RequestResolver } from 'effect';
import { AttachmentRequestError, ModelNotFoundError, ModelRequestError, } from './requests';
export const getModelResolver = (serviceUrl) => RequestResolver.fromEffect((request) => Effect.tryPromise({
    try: () => axios
        .get(`${serviceUrl}/${request.tenant}/${request.productId}-${request.articleId}.glb`, { responseType: 'blob' })
        .then(response => response.status === 200
        ? response.data
        : response.status === 403
            ? Promise.reject(new ModelNotFoundError(request.productId, request.articleId))
            : Promise.reject(response)),
    catch: error => {
        if (error instanceof ModelNotFoundError) {
            return error;
        }
        else {
            return new ModelRequestError(error);
        }
    },
}));
export const getAttachmentsResolver = (serviceUrl) => RequestResolver.fromEffect((request) => {
    return Effect.tryPromise({
        try: () => axios
            .get(`${serviceUrl}/${request.tenant}/${request.productId}-${request.articleId}.json`, { responseType: 'json' })
            .then(response => response.data),
        catch: error => new AttachmentRequestError(error),
    });
});
